<app-modal
  height="100%"
  width="auto"
  [minWidth]="modalMinWidth()"
  [compact]="true"
  aspectRatio="9 / 16"
>
  <ng-template>
    <div class="pdf-container">
      <iframe 
        [src]="pdfSrc | safe:'resourceUrl'" 
        frameborder="0" 
        class="full-width d-flex full-height"
      ></iframe>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Close'| trans:'pdf-viewer-modal/close.Button' }}
      </button>

      @if (terminalsStore.selectedTerminal() && terminalParametersMap()[terminalParameterKeys.WEB_CASH_DOCUMENTS_PRINT_DIRECTLY]) {
        <button
          class="button button--md button--primary text-uppercase"
          [disabled]="isPrinting()"
          (click)="printPdf()"
        >
          {{ 'Print'| trans:'pdf-viewer-modal/print.Button' }}
        </button>
      }
    </div>
  </ng-container>
</app-modal>
